import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Calendar, Dumbbell, Users, User, Music2 } from "lucide-react";
import { useBuddyInvites } from "../context/BuddyInvitesContext";
import { useChallenges } from "../context/ChallengesContext";

const links = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard, id: "home" },
  { to: "/calendar", label: "Plan", icon: Calendar, id: "calendar" },
  { to: "/library", label: "Lift", icon: Dumbbell, id: "workouts" },
  { to: "/coach", label: "Coach", icon: Music2, id: "coach" },
  { to: "/social", label: "Squad", icon: Users, id: "social" },
  { to: "/profile", label: "Me", icon: User, id: "profile" },
];

export default function BottomNav() {
  const { count: buddyCount } = useBuddyInvites();
  const { pendingForMe } = useChallenges();
  const socialBadge = buddyCount + (pendingForMe?.length || 0);
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 bg-neutral-950/95 backdrop-blur border-t border-neutral-800"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-3xl mx-auto grid grid-cols-6">
        {links.map((l) => {
          const badgeCount = l.id === "social" ? socialBadge : 0;
          return (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.id}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 gap-0.5 transition-all touch-manipulation select-none ${
                  isActive ? "text-blue-500" : "text-neutral-500 hover:text-white active:text-blue-500"
                }`
              }
            >
              <div className="relative">
                <l.icon className="w-5 h-5" strokeWidth={2.2} />
                {badgeCount > 0 && (
                  <span
                    data-testid="nav-buddy-badge"
                    className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 bg-blue-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center leading-none"
                  >
                    {badgeCount > 9 ? "9+" : badgeCount}
                  </span>
                )}
              </div>
              <span className="text-[9px] uppercase tracking-[0.16em] font-semibold">{l.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
